/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';
import { addUniqueById } from 'shared/lib/addUniqueById';

const initialState = [
    {
        alias: '',
        quantity: 0,
        il_opus_volume_unit_id: '',
        weight: 0,
        il_trade_partner_id: '',
        delivery_order: '-',
        delivery_order_link: '',
        customs: 'Pending',
        customs_hold: '-',
        customs_link: '',
        customs_other: '',
        proof: 'Waiting',
        proof_link: '',
        proof_date: null,
    },
];

const truckingHblUpdateSlice = createSlice({
    name: 'truckingBolUpdateForm',
    initialState: initialState,
    reducers: {
        setBolFormData: (state, action) => {
            return action.payload;
        },
        setBolUpdateData: (state, action) => {
            const { id, newData } = action.payload;
            return state.map((item) => {
                if (item.id === id) {
                    return { ...item, ...newData };
                }
                return item;
            });
        },
        addBOL: (state, action) => {
            addUniqueById(state, action.payload);
        },
        deleteBOL: (state, action) => {
            const idToDelete = action.payload;
            return state.filter((hbl) => hbl.id !== idToDelete);
        },
    },
});

export const { setBolFormData, setBolUpdateData, addBOL, deleteBOL } = truckingHblUpdateSlice.actions;
export default truckingHblUpdateSlice.reducer;
